import { brightenColor, darkenColor, decodeColor, getColorLuminance } from '@betterplace/utils'
import { useEffect, useRef, useState } from 'react'

function useDeltaColor(
  progressPercentage: number,
  intervalMs: number,
  progressColor?: string | undefined,
  progressBackgroundColor?: string | undefined,
  darkMode?: boolean | undefined
) {
  const color = decodeColor(progressColor?.toString()) || ''
  const backgroundColor = decodeColor(progressBackgroundColor?.toString())

  const [delta, setDelta] = useState(0)
  const previousPercentage = useRef(0)
  useEffect(() => {
    setDelta(progressPercentage - previousPercentage.current)
    const timeout = setTimeout(
      () => {
        setDelta(0)
        previousPercentage.current = progressPercentage
      },
      Math.round(intervalMs * 0.75)
    )
    return () => clearTimeout(timeout)
  }, [intervalMs, progressPercentage])

  const backgroundLuminance =
    backgroundColor && backgroundColor !== 'transparent' ? getColorLuminance(backgroundColor) : darkMode ? 0 : 1
  const luminanceDiff = getColorLuminance(color) - backgroundLuminance
  const increaseDiff = luminanceDiff <= 0 ? darkenColor : brightenColor
  const decreaseDiff = luminanceDiff <= 0 ? brightenColor : darkenColor
  const deltaColor = (Math.abs(luminanceDiff) > 0.49 ? decreaseDiff : increaseDiff)(color, 40)

  return { delta, deltaColor, color, backgroundColor }
}

export default useDeltaColor
